import React from 'react';

const MiniDonutIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    fill="none"
    viewBox="0 0 12 12"
    {...props}
  >
    <path
      fill="currentColor"
      d="M5.47 6.663a1.112 1.112 0 01-.2-.163c-.438-.465.056-.951.355-1.314.04-.05.156-.167.186-.203.05-.032.106-.065.145-.088.037-.016.075-.029.112-.04.043.019.033.011 0 0l.016-.004c.058.01.126.02.159.024.049.02.146.056.161.063a.435.435 0 00.024.022l.097.086c.012.02.078.102.089.119.044.067.089.133.129.203l.027.066c.041.096.077.193.11.29.017.047.057.21.06.215.025.147.038.296.041.445a2.286 2.286 0 00-.04.212c-.03.226-.252.338-.455.354a1.587 1.587 0 01-.09.005 1.244 1.244 0 01-.01 0c-.075 0-.09-.006-.051-.005-.065-.006-.13-.011-.192-.023a1.904 1.904 0 01-.674-.264zM2.364 10.42c.967.746 1.72 1.24 2.99 1.38 1.4.155 2.539-.279 3.71-.97 1.328-.786 2.439-1.85 2.766-3.237a6.602 6.602 0 00-.077-3.266c-.41-1.472-1.364-2.361-2.747-3.126C7.702.478 6.138-.096 4.69.286 3.43.616 2.286 1.34 1.542 2.42c-.07.103-.136.209-.2.317A6.093 6.093 0 00.002 6.384C-.033 7.91 1.03 9.387 2.365 10.42"
    ></path>
  </svg>
);

export default MiniDonutIcon;
